import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Select,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

const restaurantCancellationReasons = [
  'Out of stock',
  'Technical issue',
  'Quality concerns',
  'Customer unavailable',
  'Other',
];

interface CancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  cancelReason: string;
  setCancelReason: React.Dispatch<React.SetStateAction<string>>;
  handleCancelModalSubmit: () => void;
  loading: boolean;
}

export const CancelModal: React.FC<CancelModalProps> = ({
  isOpen,
  onClose,
  cancelReason,
  setCancelReason,
  handleCancelModalSubmit,
  loading,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cancel Order</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Select placeholder="Select a reason" value={cancelReason} onChange={(e) => setCancelReason(e.target.value)}>
            {restaurantCancellationReasons.map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </Select>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" onClick={handleCancelModalSubmit} isLoading={loading}>
            Cancel Order
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
